<div class="box-content rd-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetKeyFiguresScenario" class="widget-small widgetNoTopBorder widgetKeyFiguresScenario cellspacing-0 cellpadding-0" style="height: 100%;" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-small-KeyFigures">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <!-- Trad Val layout -->
    <tbody *ngIf="currentLayout === 'Trad Val'">
      <tr class="light-grey-line">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'propertyTypeCode'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10">
          <widget-value [align]="'right'">{{widgetData.propertyTypeCode | rdReflist: reflists['ref_property_type_l3']}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'tenureType'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10" *ngIf="editMode">
          <widget-value [align]="'right'">{{widgetData.tenureType}}</widget-value>
        </td>
        <td colspan="10" *ngIf="!editMode">
          <widget-value [align]="'right'">{{widgetData.tenureType}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'totalArea'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{(widgetData.totalArea || 0) | rdLocalizedNumber:0}} {{unitOfLength}}²</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'totalParkingUnits'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6" *ngIf="(widgetData.totalParkingUnits || 0) == 0">
          <widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value>
        </td>
        <td colspan="6" *ngIf="(widgetData.totalParkingUnits || 0) != 0">
          <widget-value [align]="'right'">{{(widgetData.totalParkingUnits || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line" *ngIf="widgetData.constructionYear || widgetData.renovationYear">
        <td colspan="10">
          <span *ngIf="widgetData.constructionYear"><widget-label [widget]="this" [fieldName]="'constructionYear'" [align]="'left'" class="inline"></widget-label></span>
          <span *ngIf="widgetData.constructionYear && widgetData.renovationYear">&nbsp;|&nbsp;</span>
          <span *ngIf="widgetData.constructionYear && widgetData.renovationYear"><widget-label [widget]="this" [fieldName]="'renovationYear'" [align]="'left'" class="inline"></widget-label></span>
          <span *ngIf="!widgetData.constructionYear && widgetData.renovationYear"><widget-label [widget]="this" [fieldName]="'labelRenovationYear2'" [align]="'left'" class="inline"></widget-label></span>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{widgetData.constructionYear}}<span *ngIf="widgetData.constructionYear && widgetData.renovationYear"> | </span>{{widgetData.renovationYear}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'light-grey-line': !widgetData.constructionYear && !widgetData.renovationYear, 'white-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'noOfTenants'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{(widgetData.noOfTenants || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'white-line': !widgetData.constructionYear && !widgetData.renovationYear, 'light-grey-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'mainTenant'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10">
          <widget-value [align]="'right'">{{(widgetData.mainTenant || "")}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'light-grey-line': !widgetData.constructionYear && !widgetData.renovationYear, 'white-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'occupancyRateByIncome'" [align]="'left'" class="inline"></widget-label> | <widget-label [widget]="this" [fieldName]="'occupancyRateByArea'" [align]="'left'" class="inline"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{widgetData.occupancyRateByIncome * 100 | rdLocalizedNumber:1}}% | {{widgetData.occupancyRateByArea * 100 | rdLocalizedNumber:1}}%</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'white-line': !widgetData.constructionYear && !widgetData.renovationYear, 'light-grey-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <span *ngIf="widgetData.waulb && widgetData.waulb != 0"> <widget-label [widget]="this" [fieldName]="'waulb'" [align]="'left'" class="inline"></widget-label> | </span><widget-label [widget]="this" [fieldName]="'walt'" [align]="'left'" class="inline"></widget-label>
        </td>
        <td colspan="6">
          <widget-value *ngIf="widgetData.waulbWaltFormatted" [align]="'right'">{{(widgetData.waulbWaltFormatted || 0)}} {{'keyFigures.labelYears' | rdTranslate}}</widget-value>
        </td>
      </tr>
      <tr class="dark-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'labelFinancialSnapshot'" [align]="'left'"[color]="'white'" [bold]="true"></widget-label>
        <td colspan="3">
          <widget-value [align]="'right'" [color]="'white'" [bold]="true" *ngIf="widgetData.displayValuesOverTimeId == 1">{{unitOfLength}}² / {{'keyFigures.labelYear' | rdTranslate}}</widget-value>
          <widget-value [align]="'right'" [color]="'white'" [bold]="true" *ngIf="widgetData.displayValuesOverTimeId == 2">{{unitOfLength}}² / {{'keyFigures.labelPerMonth' | rdTranslate}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" [color]="'white'" [bold]="true">{{'keyFigures.labelTotalPA' | rdTranslate}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'headlineRent'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.headlineRentPerMonthPerSqm * 12|| 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.headlineRentPerMonthPerSqm || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.headlineRent || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'passingRent'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.passingRentPerMonthPerSqm * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.passingRentPerMonthPerSqm || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.passingRent || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="11">
          <widget-label [widget]="this" [fieldName]="'totalNonRecsAnnualFirst12Months'" [align]="'left'"></widget-label>
        </td>
        <td colspan="2">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.totalNonRecoverableExpensesQmMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.totalNonRecoverableExpensesQmMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.totalNonRecsAnnualFirst12Months || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'rentFreePA'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.rentFreePA || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'noiAfterRentFreeTotal'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.noiAfterRentFreePerMonthPerSqm * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.noiAfterRentFreePerMonthPerSqm || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.noiAfterRentFreeTotal || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'grossErv'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.grossMarketRentPerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.grossMarketRentPerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.grossErv || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'netErvTotal'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.netErvPerMonthPerSqm * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.netErvPerMonthPerSqm || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.netErvTotal || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'reversion'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{(widgetData.reversion || 0) * 100 | rdLocalizedNumber:1}} %</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'capitalExpenditures'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.capitalExpenditures || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
    </tbody>

    <!-- DCF layout -->
    <tbody *ngIf="currentLayout === 'DCF'">
      <tr class="light-grey-line">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'propertyTypeCode'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10">
          <widget-value [align]="'right'">{{widgetData.propertyTypeCode | rdReflist: reflists['ref_property_type_l3']}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'tenureType'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10" *ngIf="editMode">
          <widget-value [align]="'right'">{{widgetData.tenureType}}</widget-value>
        </td>
        <td colspan="10" *ngIf="!editMode">
          <widget-value [align]="'right'">{{widgetData.tenureType}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'totalArea'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{(widgetData.totalArea || 0) | rdLocalizedNumber:0}} {{unitOfLength}}²</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'totalParkingUnits'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6" *ngIf="(widgetData.totalParkingUnits || 0) == 0">
          <widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value>
        </td>
        <td colspan="6" *ngIf="(widgetData.totalParkingUnits || 0) != 0">
          <widget-value [align]="'right'">{{(widgetData.totalParkingUnits || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line" *ngIf="widgetData.constructionYear || widgetData.renovationYear">
        <td colspan="10">
          <span *ngIf="widgetData.constructionYear"><widget-label [widget]="this" [fieldName]="'constructionYear'" [align]="'left'" class="inline"></widget-label></span>
          <span *ngIf="widgetData.constructionYear && widgetData.renovationYear">&nbsp;|&nbsp;</span>
          <span *ngIf="widgetData.constructionYear && widgetData.renovationYear"><widget-label [widget]="this" [fieldName]="'renovationYear'" [align]="'left'" class="inline"></widget-label></span>
          <span *ngIf="!widgetData.constructionYear && widgetData.renovationYear"><widget-label [widget]="this" [fieldName]="'labelRenovationYear2'" [align]="'left'" class="inline"></widget-label></span>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{widgetData.constructionYear}}<span *ngIf="widgetData.constructionYear && widgetData.renovationYear"> | </span>{{widgetData.renovationYear}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'light-grey-line': !widgetData.constructionYear && !widgetData.renovationYear, 'white-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'noOfTenants'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{(widgetData.noOfTenants || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'white-line': !widgetData.constructionYear && !widgetData.renovationYear, 'light-grey-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="6">
          <widget-label [widget]="this" [fieldName]="'mainTenant'" [align]="'left'"></widget-label>
        </td>
        <td colspan="10">
          <widget-value [align]="'right'">{{(widgetData.mainTenant || "")}}</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'light-grey-line': !widgetData.constructionYear && !widgetData.renovationYear, 'white-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'occupancyRateByIncome'" [align]="'left'" class="inline"></widget-label> | <widget-label [widget]="this" [fieldName]="'occupancyRateByArea'" [align]="'left'" class="inline"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{widgetData.occupancyRateByIncome * 100 | rdLocalizedNumber:1}}% | {{widgetData.occupancyRateByArea * 100 | rdLocalizedNumber:1}}%</widget-value>
        </td>
      </tr>
      <tr [ngClass]="{'white-line': !widgetData.constructionYear && !widgetData.renovationYear, 'light-grey-line': widgetData.constructionYear || widgetData.renovationYear}">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'walt'" [align]="'left'" class="inline"></widget-label>
        </td>
        <td colspan="3">
          &nbsp;
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{(widgetData.walt || 0) | rdLocalizedNumber:1}} {{'keyFigures.labelYears' | rdTranslate}}</widget-value>
        </td>
      </tr>
      <tr class="dark-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'labelFinancialSnapshot'" [align]="'left'" [color]="'white'" [bold]="true"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" [color]="'white'" [bold]="true" *ngIf="widgetData.displayValuesOverTimeId == 1">{{unitOfLength}}² / {{'keyFigures.labelYear' | rdTranslate}}</widget-value>
          <widget-value [align]="'right'" [color]="'white'" [bold]="true" *ngIf="widgetData.displayValuesOverTimeId == 2">{{unitOfLength}}² / {{'keyFigures.labelPerMonth' | rdTranslate}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" [color]="'white'" [bold]="true">{{'keyFigures.labelTotalPA' | rdTranslate}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'dcfEffectiveGrossRevenue'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfEffectiveGrossRevenuePerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfEffectiveGrossRevenuePerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfEffectiveGrossRevenue || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="11">
          <widget-label [widget]="this" [fieldName]="'dcfTotalOperatingExpenses'" [align]="'left'"></widget-label>
        </td>
        <td colspan="2">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfTotalOperatingExpensesPerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfTotalOperatingExpensesPerAreaPerMonth|| 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfTotalOperatingExpenses || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'dcfNetOperatingIncome'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfNetOperatingIncomePerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfNetOperatingIncomePerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfNetOperatingIncome || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'labelTenantRentalValue'" [align]="'left'"></widget-label>
        </td>
        <td colspan="6">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.grossErv || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'reversion'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          &nbsp;
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{(widgetData.reversion || 0) * 100 | rdLocalizedNumber:1}} %</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'dcfEffectiveGrossRevenueYear1'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfEffectiveGrossRevenueYear1PerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfEffectiveGrossRevenueYear1PerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfEffectiveGrossRevenueYear1 || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'dcfNetOperatingIncomeYear1'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfNetOperatingIncomeYear1PerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfNetOperatingIncomeYear1PerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfNetOperatingIncomeYear1 || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'dcfTotalLeasingCapitalCosts'" [align]="'left'"></widget-label>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{currency}} {{(widgetData.dcfTotalLeasingCapitalCostsPerAreaPerMonth * 12 || 0) | rdLocalizedNumber:2}}</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{currency}} {{(widgetData.dcfTotalLeasingCapitalCostsPerAreaPerMonth || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.dcfTotalLeasingCapitalCosts || 0) | rdLocalizedNumber:0}}</widget-value>
        </td>
      </tr>
    </tbody>
  </table>
</div>
